import { Grid, styled } from "@material-ui/core";
import { observer } from "mobx-react";
import { KanbanStore } from "../../store";
import ContractCard from "./ContractCard";

const KanbanWrapper = styled(Grid)(({ theme }) => ({
  width: "100vw",
  padding: theme.spacing(8),
}));

const ContractsKanban = observer(() => {
  const filteredContracts = KanbanStore.filteredContracts;

  return (
    <KanbanWrapper container spacing={4}>
      {filteredContracts.map((contract) => (
        <Grid key={contract.uid} item xs={12} md={4} lg={3}>
          <ContractCard
            id={contract.uid}
            project={contract.development.name}
            name={contract.name}
            client={contract.development.customer}
            location={contract.development.local}
            value={contract.total}
            measuredValue={contract.getBillingPercentual()}
            status={contract.status}
            imageUrl={contract.coverImageUrl}
          ></ContractCard>
        </Grid>
      ))}
    </KanbanWrapper>
  );
});

export default ContractsKanban;
